import {Order, orderDecoder} from './Order'
import {BpsUser, bpsUserDecoder} from './BpsUser'
import {Customer, customerDecoder} from './Customer'
import {Company, companyDecoder} from './Company'
import {
    ProductShippingServiceForOrder,
    productShippingServiceForOrderDecoder
} from './ProductShippingServiceForOrder'
import {
    PositionWithProduct,
    positionWithProductDecoder
} from './PositionWithProduct'
import {array, Decoder, field, object} from 'json-bouncer'
import {
    OrderProtocolWithDetails,
    orderProtocolWithDetailsDecoder
} from './OrderProtocolWithDetails'

export interface OrderWithDetails {
    order: Order
    bpsUser: BpsUser
    customer: Customer
    company: Company
    orderProtocolsWithDetails: OrderProtocolWithDetails[]
    positionsWithProducts: PositionWithProduct[]
    productShippingServicesForOrder: ProductShippingServiceForOrder[]
}

export function orderWithDetailsDecoder(): Decoder<OrderWithDetails> {
    return object({
        order: field('order', orderDecoder()),
        bpsUser: field('bpsUser', bpsUserDecoder()),
        customer: field('customer', customerDecoder()),
        company: field('company', companyDecoder()),
        orderProtocolsWithDetails:
            field(
                'orderProtocolsWithDetails',
                array(orderProtocolWithDetailsDecoder()),
            ),
        positionsWithProducts:
            field(
                'positionsWithProducts',
                array(positionWithProductDecoder()),
            ),
        productShippingServicesForOrder:
            field(
                'productShippingServicesForOrder',
                array(productShippingServiceForOrderDecoder()),
            ),
    })
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/OrderWithDetails.ts